import { BehaviorSubject } from 'rxjs';

const prefix = 'dok-';

export class LocalStorageUtils {
  static readonly storage = localStorage;

  static set<T>(key: string, value: T): void {
    if (value === undefined) {
      this.storage.removeItem(prefix + key);
      return;
    }
    this.setString(key, JSON.stringify(value));
  }

  static get<T>(key: string): T | undefined {
    try {
      return JSON.parse(this.getString(key));
    } catch {
      // an older bundle could store the literal `undefined`; parsing that threw out of every
      // LocalStorageSubject constructor, so the page never rendered and only clearing site data helped
      this.storage.removeItem(prefix + key);
      return undefined;
    }
  }

  static has(key: string): boolean {
    return this.storage.getItem(prefix + key) !== null;
  }

  private static setString(key: string, value: string): void {
    this.storage.setItem(prefix + key, value);
  }

  private static getString(key: string): string {
    return this.storage.getItem(prefix + key) ?? '""';
  }
}

export class LocalStorageSubject<T> extends BehaviorSubject<T> {
  private readonly key: string;

  constructor(localStorageKey: string, startValue: T) {
    const storedValue = LocalStorageUtils.get<T>(localStorageKey);
    super(!storedValue ? startValue : storedValue);
    this.key = localStorageKey;
  }

  override next(value: T): void {
    LocalStorageUtils.set(this.key, value);
    super.next(value);
  }
}
